import { useCallback } from 'react';
import {
  useSharedValue,
  useAnimatedStyle,
  withSpring,
} from 'react-native-reanimated';

import { animation } from '../tokens';

export function useSpringPress(scaleDown = 0.97) {
  const scale = useSharedValue(1);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ scale: scale.value }],
  }));

  const onPressIn = useCallback(() => {
    scale.value = withSpring(scaleDown, animation.spring.snappy);
  }, [scale, scaleDown]);

  const onPressOut = useCallback(() => {
    scale.value = withSpring(1, animation.spring.gentle);
  }, [scale]);

  return { animatedStyle, onPressIn, onPressOut };
}
